<template>
 <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
   <com-header ref="header"/>
   <div class="nav-list">
     <div class="nav-item" :class="{ 'nav-item-left-hover': navId === '1' }" @click="navClick('1')">推荐</div>
     <div class="nav-item" :class="{ 'nav-item-right-hover': navId === '2' }" @click="navClick('2')">新品</div>
   </div>
   <div class="page-box-search-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
     <com-card :imgList="imgList" :total="imgList.length" v-if="imgList.length > 0" @collectCall="collectCall"/>
   </div>
 </div>
</template>

<script>
export default {
  name: "newProduct",
  data(){
    return {
      navId: '1',
      loading: true,
      imgList:[],
      imgBg:''
    }
  },
  mounted(){
    this.getRecommendList()
    this.getImgBg()
  },
  methods: {
    getImgBg() {
      this.$get('/pc/shop/bgimg', {id: 'newprod'}).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    navClick(id){
      this.navId = id
      this.imgList = []
      if(id === '1'){
        this.getRecommendList()
      }else{
        this.getNewprodList()
      }
    },
    getRecommendList() {
      this.$get('/pc/shop/recommend', {}).then((res) => {
        this.imgList = res.data
      }).catch((error) => {
      })
    },
    getNewprodList() {
      this.$get('/pc/shop/newprod', {}).then((res) => {
        this.imgList = res.data
      }).catch((error) => {
      })
    },
    collectCall(data) {
      this.$refs.header.getCollect()
      this.imgList.forEach((item) => {
        if (item.id === data.id) {
          if (item.iscollect === 0) {
            item.iscollect = 1
            item.collection = Number(item.collection) + 1
          } else {
            item.iscollect = 0
            item.collection = Number(item.collection) - 1
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
.nav-list {
  display: flex;
  align-items: center;
  width: 418px;
  height: 64px;
  border: 3px solid #E8B45E;
  margin: 50px auto 0;
  border-radius: 32px;
  box-sizing: border-box;
  .nav-item {
    width: 50%;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 64px;
  }
  .nav-item-left-hover{
    width: 50%;
    height: 100%;
    background: #E8B45E;
    color:#222222;
    border-radius: 32px 0 0 32px;
  }
  .nav-item-right-hover{
    width: 50%;
    height: 100%;
    background: #E8B45E;
    color:#222222;
    border-radius: 0 32px 32px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/newProduct.vue